import uniqBy from 'lodash/uniqBy';

interface MapAddress {
  properties: { label: string };
  geometry: { coordinates: string[] };
}

export interface FormattedMapAddress {
  label: string;
  value: string;
  position: { lng: string; lat: string };
}

export default function formatAddresses({
  features
}: {
  features: MapAddress[];
}): FormattedMapAddress[] {
  return uniqBy(features, 'properties.label').map(
    ({
      properties: { label },
      geometry: {
        coordinates: [lng, lat]
      }
    }) => ({
      label,
      value: label,
      position: { lng, lat }
    })
  );
}
